/**
 * Extracts the package-size UOM used for partial quantities
 * (e.g. "30 ML" → "ML"), matching table display behavior.
 */
export const getPackageSizeUom = (
  packageSize?: string | number | null
): string => {
  if (packageSize === undefined || packageSize === null || packageSize === '') {
    return '';
  }

  const str = String(packageSize).trim();
  const parts = str.split(/\s+/).filter(Boolean);

  if (parts.length > 1) {
    return parts.slice(1).join(' ');
  }

  return str.replace(/[^a-zA-Z]/g, '').trim();
};

/**
 * Extracts the numeric package size for pricing math
 * (e.g. "30 ML" → 30). `Number("30 ML")` is NaN and must not be used.
 */
export const getPackageSizeNumeric = (
  packageSize?: string | number | null
): number => {
  if (packageSize === undefined || packageSize === null || packageSize === '') {
    return 0;
  }

  const cleanSize = String(packageSize).replace(/[^0-9.]/g, '');
  return parseFloat(cleanSize) || 0;
};
